import store from '@/plugins/vuex'

const routes = [
  {
    path: '/label/my-artists',
    name: 'My Artists',
    beforeEnter(to, from, next) {
      store.commit('artistDashboard/setSelectedTrack', null)
      store.commit('artistDashboard/setSelectedArtist', null)
      next()
    },
    component: () =>
      import(/* webpackChunkName: 'my-artists-label' */ './views/Index.vue')
  },
  {
    path: '/label/my-artists/tracks',
    name: 'Artist Tracks',
    beforeEnter(to, from, next) {
      if (store.state.artistDashboard.artist_label == null) {
        next({
          name: 'My Artists'
        })
      } else {
        next()
      }
    },
    component: () =>
      import(
        /* webpackChunkName: 'my-artists-tracks-label' */ './views/Tracks.vue'
      )
  },
  {
    path: '/label/my-artists/campaign',
    name: 'Artist Campaigns',
    beforeEnter(to, from, next) {
      if (store.state.artistDashboard.artist_label == null) {
        next({
          name: 'My Artists'
        })
      } else {
        next()
      }
    },
    component: () =>
      import(
        /* webpackChunkName: 'my-artists-vidcents-label' */ './views/Vidcents.vue'
      )
  },
  {
    path: '/label/my-artists/artist',
    name: 'Label Artist Dashboard',
    beforeEnter(to, from, next) {
      if (store.state.artistDashboard.artist_label == null) {
        next({
          name: 'My Artists'
        })
      } else {
        store.commit('artistDashboard/setSelectedTrack', null)
        store.commit('artistTrackVidCents/setActiveCampaign', {})
        next()
      }
    },
    component: () =>
      import(
        /* webpackChunkName: 'my-artists-dashboard-label' */ './views/Artist.vue'
      )
  }
]

export default routes
